import { useEffect } from 'react';
import { useStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

const initialState = {
  hasLocalSession: false,
};

export type LocalSessionStore = {
  hasLocalSession: boolean;

  // Actions
  setHasLocalSession: (hasLocalSession: boolean) => void;
};

export const LOCAL_SESSION_STORE_KEY = 'localSessionStore';

/**
 * This is used to keep track of the user login state locally
 */

export const localSessionStore = createStore<LocalSessionStore>()(
  persist(
    (set) => ({
      ...initialState,
      setHasLocalSession: (hasLocalSession) => set({ hasLocalSession }),
    }),
    { name: LOCAL_SESSION_STORE_KEY },
  ),
);

export const useLocalSessionStore = (): LocalSessionStore => useStore(localSessionStore);

// This code will reload other tabs whenever the local session state changes (on login/logout)
export const useLocalSessionSync = () => {
  useEffect(() => {
    const refreshLocalSession = (e: StorageEvent) => {
      if (e.key === LOCAL_SESSION_STORE_KEY) {
        const newValue = e.newValue ? JSON.parse(e.newValue) : null;
        const currentHasSession = localSessionStore.getState().hasLocalSession;
        const newHasSession = newValue?.state?.hasLocalSession ?? false;

        if (currentHasSession !== newHasSession) {
          window.location.reload();
        }
      }
    };

    window.addEventListener('storage', refreshLocalSession);

    return () => {
      window.removeEventListener('storage', refreshLocalSession);
    };
  }, []);
};
